module.exports = __webpack_public_path__ + "img/icon_love_active.7a893bab.png";